import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { ThreeDots } from 'assets/icons/ThreeDots'
import { DashboardCardHeadline, SquareIcon } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

interface ITitle {
  mainIcon?: JSX.Element
  title: string
  subtitle?: string
  color?: string
  rightSide?: JSX.Element
  height?: string
  center?: boolean
  onClick?: () => void
  arrow?: boolean
  dots?: boolean
}

export const Title = ({
  mainIcon,
  title,
  color,
  rightSide,
  height,
  center,
  onClick,
  arrow,
  dots,
}: ITitle) => {
  return (
    <DashboardCardHeadline height={height} center={center}>
      <div>
        {mainIcon && <SquareIcon color={color}>{mainIcon}</SquareIcon>}
        <div>
          <TitleText weight='bold'>{title.toLocaleUpperCase()}</TitleText>
        </div>
      </div>
      {rightSide ?? (
        <span style={{ cursor: 'pointer' }} onClick={() => onClick && onClick()}>
          {arrow ? <ArrowLeft /> : dots ? <ThreeDots /> : null}
        </span>
      )}
    </DashboardCardHeadline>
  )
}
